export const requestIsJaguar = () => {
  const hosts = {
    development: "localhost:8000",
    production: "jaguargift.com"
  };

  const targetHost = hosts[process.env.NODE_ENV];
  const locationHostMatch = window.location.host === targetHost;
  const ancestorOriginsMatch = Array.from(window.location.ancestorOrigins || []).some(
    origin => new URL(origin).host === targetHost
  );

  return locationHostMatch || ancestorOriginsMatch;
};